<template>
    <div>
        <v-btn v-if="reducido" icon color="white" @click="mostrarDialogo = true" :disabled="cargando">
            <v-icon>mdi-upload</v-icon>
        </v-btn>
        <v-btn v-if="!reducido" color="primary" depressed @click="mostrarDialogo = true" :disabled="cargando">
            {{$t('anyadir_muestreos')}}
        </v-btn>

        <v-dialog v-model="mostrarDialogo" width="500">
            <v-card>
                <v-card-title class="headline primary white--text" primary-title>
                    {{$t('anyadir_muestreos')}}
                </v-card-title>

                <v-card-text>
                    <div class="body-1 pt-4">
                        <v-alert v-if="mensajeError.length > 0" type="error">
                            {{mensajeError}}
                        </v-alert>
                        {{$t('anyadir_muestreos_descrip')}}
                        <v-form ref="form" lazy-validation>
                            <v-file-input v-model="file" :rules="[requerido]" @change="cargarDatosFichero()">
                            </v-file-input>
                        </v-form>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="mostrarDialogo = false">
                        {{$t('cerrar')}}
                    </v-btn>
                    <v-btn color="success" text :disabled="!formValido()" :loading="cargando"
                           @click="subirMuestreos()">
                        {{$t('anyadir')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import {HttpHelper} from "../../../comunes/helpers/HttpHelper";

    export default {
        name: "BtnSubirMuestreos",
        data: () => ({
            mostrarDialogo: false,
            mensajeError: "",
            file: null,
            datosFile: null,
            cargando: false
        }),
        props:{
          reducido: {type: Boolean, required: true}
        },
        methods: {
            requerido(value) {
                return !!value || this.$t('requerido')
            },
            formValido() {
                if (this.file == null) return false;
                if (this.datosFile == null) return false;

                return true;
            },
            obtenerMuestreos() {
                this.muestreos.cargando = true;

                HttpHelper.get(`admin/muestreos/listado`)
                    .then((muestreos) => {
                        this.muestreos = muestreos;
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.muestreos.cargando = false;
                    });
            },
            cargarDatosFichero() {
                this.datosFile = null;
                if (this.file == null) return;

                let fileReader = new FileReader();

                fileReader.addEventListener("load", (e) => {
                    this.datosFile = e.target.result;
                });

                try {
                    fileReader.readAsDataURL(this.file);
                } catch (e) {
                    this.file = null;
                    this.datosFile = null;
                }
            },
            resetFormulario() {
                this.$refs.form.reset();
                this.datosFile = null;
            },
            subirMuestreos() {
                this.cargando = true;
                this.mensajeError = "";
                let params = {
                    nombre: this.file.name,
                    tamanyo: this.file.size,
                    tipo: this.file.type,
                    datos: this.datosFile
                };

                HttpHelper.post(`admin/muestreos/subir-muestreos`, params)
                    .then(() => {
                        this.mostrarDialogo = false;
                        this.resetFormulario();
                        this.$emit('change');
                    })
                    .catch((res) => {
                        this.mensajeError = res && res.mensaje ? res.mensaje : this.$t("error_desconocido");
                    })
                    .finally(() => {
                        this.cargando = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>

<!-- @formatter:off -->
<i18n>
    {
    "es": {
    "requerido": "Requerido",
    "anyadir_muestreos": "Añadir muestreos",
    "anyadir_muestreos_descrip": "Selecciona un fichero excel que incluya los muestreos",
    "anyadir": "Añadir",
    "cerrar": "Cerrar",
    "error_muestreos": "Error en muestreos",
    "error_desconocido": "Se ha producido un error desconocido al procesar los muestreos"
    }
    }
</i18n>
<!-- @formatter:on -->